import React from 'react';
import { FolderViewMode } from 'components/FolderViewer/FolderViewModeContext';
import { ListItem } from './ListItem';
import { GridItem } from './GridItem';
import { TableItem } from './TableItem';
import { InlineItem, InlineItemPlaceHolder } from './InlineItem';
import { ItemMenu_node$key } from './ItemMenu/__generated__/ItemMenu_node.graphql';
import { useItemHandleFragmentProps } from 'components/ItemHandle';
import { UploadingHandleProps } from 'components/ItemHandle/components/UploadingHandle';
import { DateSortOption } from 'components/Folder';

export type LoadedItemProps = SelectableItemProps & {
  node?: ItemMenu_node$key & useItemHandleFragmentProps['item'];
  parentConnectionId?: string;
  dateColumn?: DateSortOption;
};

export type UploadingItemProps = UploadingHandleProps &
  SelectableItemProps & {
    cancelUpload?: () => void;
  };

export type SelectableItemProps = {
  onSelectChange?(): void;
  isSelected?: boolean;
};

export interface ItemProps extends LoadedItemProps, UploadingItemProps {
  isLoading?: boolean;
  dateColumn?: DateSortOption;
  onClick?: () => void;
}

export const Item = ({
  viewMode,
  ...props
}: ItemProps & { viewMode: FolderViewMode }) => {
  switch (viewMode) {
    case 'grid':
      return <GridItem {...props} />;
    case 'inline':
      return <InlineItem {...props} />;
    case 'list':
      return <ListItem linkBox {...props} />;
    case 'table':
      return <TableItem {...props} />;
  }
};

export type ItemPlaceholderProps = {
  name: string;
  onClick?(): void;
  viewMode: FolderViewMode;
};

export const ItemPlaceholder = (props: ItemPlaceholderProps) => {
  switch (props.viewMode) {
    case 'inline':
      return <InlineItemPlaceHolder {...props} />;
    default:
      throw new Error(
        `viewmode ${props.viewMode} no supported on ItemPlaceholder`,
      );
  }
};
